import React from 'react'
import { Helmet } from 'react-helmet'
import { generateAlternateLinks, generateTitleAndMetaTags } from 'src/utils/seo'

const SeoNewsSlug = ({ title, description, slug }) => {
  return (
    <Helmet>
      {generateTitleAndMetaTags(title, description)}
      {generateAlternateLinks(`/news/${slug}`)}
      <script type='application/ld+json'>
        {`{
          "@context": "https://schema.org/", 
          "@type": "BreadcrumbList", 
          "itemListElement": [{
            "@type": "ListItem", 
            "position": 1, 
            "name": "News",
            "description": "Explore the latest updates in leading jewelry design software, including MatrixGold and CounterSketch.",
            "item": "https://gemvision.com/news"  
          },
          {
            "@type": "ListItem", 
            "position": 2, 
            "name": "${title}",
            "description": "Explore the latest updates in leading jewelry design software, including MatrixGold and CounterSketch.",
            "item": "https://gemvision.com/news/${slug}"  
          },
          ]
        }`}
      </script>
    </Helmet>
  )
}

export default React.memo(SeoNewsSlug)
